import { env } from '@/env';

const KEYCLOAK_URL = env.keycloakUrl;
const KEYCLOAK_REALM = env.keycloakRealm;
const KEYCLOAK_CLIENT_ID = env.keycloakClientId;

const TOKEN_URL = `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/token`;

/**
 * Keycloak account-console URL - where a user manages their own password and
 * sign-in details. Password changes live in Keycloak (not the app backend), so
 * the profile's "Change password" action opens this.
 */
export function keycloakAccountUrl(): string {
  return `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/account/`;
}

export interface KeycloakTokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  refresh_expires_in: number;
  token_type: string;
}

/**
 * Direct grant (Resource Owner Password Credentials) login.
 * Calls Keycloak's token endpoint with grant_type=password.
 */
export async function keycloakLogin(
  email: string,
  password: string,
): Promise<KeycloakTokenResponse> {
  const body = new URLSearchParams({
    grant_type: 'password',
    client_id: KEYCLOAK_CLIENT_ID,
    username: email,
    password,
  });

  const res = await fetch(TOKEN_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  if (!res.ok) {
    throw new Error('Invalid credentials');
  }

  return res.json();
}

/**
 * Refresh an access token using a refresh token.
 */
export async function keycloakRefresh(refreshToken: string): Promise<KeycloakTokenResponse> {
  const body = new URLSearchParams({
    grant_type: 'refresh_token',
    client_id: KEYCLOAK_CLIENT_ID,
    refresh_token: refreshToken,
  });

  const res = await fetch(TOKEN_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  if (!res.ok) {
    throw new Error('Token refresh failed');
  }

  return res.json();
}
